import React from "react";
import PropTypes from "prop-types";
import { Badge } from "@opendate-app/setlist";

export const promoCodeAppliesDiscount = ({ revealsHiddenTickets, percentage, amount }) =>
  !revealsHiddenTickets || Number(percentage) > 0 || Number(amount) > 0;

const PromoCodeTypeBadges = ({ reveals, discounts }) => (
  <span style={{ display: "inline-flex", flexWrap: "wrap", gap: "4px" }}>
    {reveals ? <Badge color="purple" size="sm">Reveals hidden tickets</Badge> : null}
    {discounts ? <Badge color="brand" size="sm">Applies discount</Badge> : null}
  </span>
);

PromoCodeTypeBadges.propTypes = {
  reveals: PropTypes.bool,
  discounts: PropTypes.bool,
};

export default PromoCodeTypeBadges;
